import { CustomerAssortment } from 'views/order-feed/types/customer-assortment.type';

const CustomerAssortmentData: CustomerAssortment = {
  availableProducts: [
    {
      itemName: '80 SLICE VET 8MG/KG 500KG - NORWEGIAN LONG TEXT',
      itemNumber: '000000000107551866',
      packaging: '',
      validityRanges: [{ validFrom: '2023-01-01T00:00:00', validTo: '2023-03-01T00:00:00' }],
    },
    {
      itemName: 'EWOS MICRO 80 DERMIC 70A 500KG - NORWEGIAN LONG TEXT',
      itemNumber: '000000000107551870',
      packaging: '500KG',
      validityRanges: [{ validFrom: '2021-11-01T00:00:00', validTo: '9999-12-31T00:00:00' }],
    },
    {
      itemName: 'MONO AMMONIUM PHOSPHATE MAP POWER TECHNICAL BAG',
      itemNumber: '000000000107551933',
      packaging: '',
      validityRanges: [{ validFrom: '2021-12-01T00:00:00', validTo: '9999-12-31T00:00:00' }],
    },
    {
      itemName: 'EWOS RAPID HP 1000 30A BLK',
      itemNumber: '000000000107551964',
      packaging: 'BLK',
      validityRanges: [{ validFrom: '2021-11-01T00:00:00', validTo: '2022-12-31T00:00:00' }],
    },
    {
      itemName: 'EWOS EXTRA HP 1000 50A 500',
      itemNumber: '000000000107551982',
      packaging: '500',
      validityRanges: [{ validFrom: '2022-03-01T00:00:00', validTo: '9999-12-31T00:00:00' }],
    },
    {
      itemName: 'EWOS MICRO 40 500KG',
      itemNumber: '000000000107551992',
      packaging: '',
      validityRanges: [{ validFrom: '2021-11-01T00:00:00', validTo: '9999-12-31T00:00:00' }],
    },
    {
      itemName: 'EWOS RAPID HP 1000 HQ 50A 500',
      itemNumber: '000000000107553222',
      packaging: '',
      validityRanges: [{ validFrom: '2022-03-01T00:00:00', validTo: '9999-12-31T00:00:00' }],
    },
    {
      itemName: 'EWOS RAPID HP 1000 DERMIC 50A 500',
      itemNumber: '000000000107553256',
      packaging: '500',
      validityRanges: [{ validFrom: '2022-03-01T00:00:00', validTo: '9999-12-31T00:00:00' }],
    },
    {
      itemName: 'EWOS EXTRA HP 1000 50A BLK',
      itemNumber: '000000000107555106',
      packaging: 'BLK',
      validityRanges: [
        { validFrom: '2021-11-01T00:00:00', validTo: '2022-12-31T00:00:00' },
        { validFrom: '2023-01-01T00:00:00', validTo: '9999-12-31T00:00:00' },
      ],
    },
    {
      itemName: 'EWOS RAPID HP 1000 HQ 50A BLK',
      itemNumber: '000000000107551259',
      packaging: 'BLK',
      validityRanges: [{ validFrom: '2022-04-05T00:00:00', validTo: '9999-12-31T00:00:00' }],
    },
  ],
  preferredProducts: [
    {
      itemName: 'EWOS HARMONY DEBIO 1000 0.2PF NP750',
      itemNumber: '000000000107550859',
      packaging: '',
      validityRanges: [{ validFrom: '2022-03-01T00:00:00', validTo: '9999-12-31T00:00:00' }],
    },
    {
      itemName: 'EWOS RAPID HP 1000 HQ 50A BLK',
      itemNumber: '000000000107551259',
      packaging: 'BLK',
      validityRanges: [{ validFrom: '2022-04-05T00:00:00', validTo: '9999-12-31T00:00:00' }],
    },
    {
      itemName: 'EWOS RAPID A HP 1000 50A 500',
      itemNumber: '000000000107551846',
      packaging: '',
      validityRanges: [{ validFrom: '2022-01-01T00:00:00', validTo: '9999-12-31T00:00:00' }],
    },
  ],
};

export default CustomerAssortmentData;